import inView from 'in-view';

document.addEventListener('DOMContentLoaded', () => {
  // -------------
  // In view
  // https://github.com/camwiegert/in-view
  // -------------
  inView.threshold(0.5); // 50% of element must be visible to trigger

  // adds 'visible' class once when it becomes visible
  inView('.iv-once').on('enter', (el) => {
    el.classList.add('visible');
  });

  inView('.iv-once-children > *').on('enter', (el) => {
    el.classList.add('visible');
  });

  // adds 'visible' class when it becomes visible, then removes class when it stops being visible
  inView('.iv-repeat')
    .on('enter', (el) => {
      el.classList.add('visible');
    })
    .on('exit', (el) => {
      el.classList.remove('visible');
    });

  inView('.iv-pop').on('enter', (el) => {
    el.classList.add('visible');
  });

  document.querySelectorAll('.iv-once').forEach((el) => {
    const rect = el.getBoundingClientRect();
    const inViewport =
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0;
    if (inViewport) {
      el.classList.add('visible');
    }
  });
});
